// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/_css-loader@5.2.7@css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7aa0873b] .account{display:flex}[data-v-7aa0873b] .account .ivu-modal{margin:auto;top:0}[data-v-7aa0873b] .account .ivu-modal .ivu-modal-content{border-radius:4px;height:550px;width:430px}[data-v-7aa0873b] .account .ivu-modal .ivu-modal-content .ivu-modal-body{height:100%;padding:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
